import Vue from 'vue'
import VueAMap from 'vue-amap'
import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/moment.js'
import './plugins/axios.js'
import './plugins/common.js'
import './utils/rem'
import 'normalize.css' // A modern alternative to CSS resets
import './styles/c.less'
import './styles/index.less'
import './components'
import './filter'
import './assets/icons/index'
import echarts from 'echarts'
import i18n from "@/i18n/i18n.js"; 

import PopupMessage from '@/components/common/PopupMessage.vue';
let popupMessage = null;
let init = () => {
  let messageConstructor = Vue.extend(PopupMessage);
  // 构造函数可以传参，data，method
  popupMessage = new messageConstructor({});
  popupMessage.$mount();
  document.body.appendChild(popupMessage.$el);
}

let caller = (options) => {
  init(options);
  // PopupMessage.vue 中使用getParams接收调用时传入的参数。 type: image等
  popupMessage.getParams(options);
}

Vue.use(ElementUI, { size: 'small' })
Vue.use(VueAMap)
Vue.use(i18n); 
VueAMap.initAMapApiLoader({
  key: 'b4a36135d0c10df1b84e8e73edc87de3',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geocoder',
    'AMap.Geolocation',
    'AMap.CitySearch'
  ]
})

window._AMapSecurityConfig = {
  securityJsCode: '5c21fc9ca8893b2c797d0fe39ef18f63'
}

// 解决高德地图刷新显示不出来
const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/))
amapKeys.forEach(key => { localStorage.removeItem(key) })
Vue.prototype.$popupMessage = caller;
Vue.prototype.$echarts = echarts
Vue.prototype.$eventBus = new Vue()
Vue.config.productionTip = false
new Vue({
	router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
